<ion-app>
  @if (!pwaAuthChecked()) {
    <div id="main" class="auth-form auth-form--loading">
      <h2>Loading</h2>
    </div>
  }

  @else if (!showCloudLogin()) {
    <ion-router-outlet [swipeGesture]="false"></ion-router-outlet>
  }

  @else {
    <div id="main" class="auth-form">
      <h2>Login</h2>
      @if (cloudLoginMessage()) {
        <p class="error">{{ cloudLoginMessage() }}</p>
      }
      <form (submit)="loginCloud(usernameInput.value, passwordInput.value); $event.preventDefault()">
        <div class="auth-form-block">
          <label for="username">Username: </label>
          <input type="text" id="username" #usernameInput placeholder="Username" required>
        </div>
        <div class="auth-form-block">
          <label for="password">Password: </label>
          <input type="password" id="password" #passwordInput placeholder="Password" required>
        </div>
        <div class="auth-form-block">
          <button type="submit">Login</button>
        </div>
      </form>
    </div>
  }
</ion-app>
